import { Utility, utility_controller, getTargetContainers, getTargetContainersExceptPageOverlay } from '../utility/utility_controller'
import restoreLoadMore from '../utility/restoreLoadMore'

var $grids = undefined
const rowsToShowDefaults = { desktop: 3, tablet: 3, phone: 6 }

var onResize = function () {
	if (typeof $grids != 'undefined') {
		$grids.each(function () {
			var $el = jQuery(this)
			var config = $el.data('config')
			sizeLayout($el, config)
		})
	}
}

var sizeLayout = function ($el, config) {
	var currentDevice = Utility.screenSize

	var colGutter = config[currentDevice].colGutter
	var colCount = config[currentDevice].colCount

	var rowGutterMu = typeof config[currentDevice].rowGutterMu === 'undefined' ? '%' : config[currentDevice].rowGutterMu
	var colGutterMu = typeof config[currentDevice].colGutterMu === 'undefined' ? '%' : config[currentDevice].colGutterMu

	// took this calculation from "layout_functions.php"
	var gutter_diff = (1 - 1 / colCount) * config[currentDevice].colGutter
	var width = 'calc( 100% / ' + colCount + ' - ' + gutter_diff + colGutterMu + ')'

	var elementHeightsDefaults = {
		desktop: 200,
		tablet: 150,
		phone: 80,
	}

	let elementHeight = typeof config[currentDevice].elementHeight === 'undefined' ? elementHeightsDefaults[currentDevice] : config[currentDevice].elementHeight

	var layoutType = config.layoutType
	switch (layoutType) {
		case 'masonry':
			$el.find('.element-wrap').each(function () {
				var s = jQuery(this).attr('data-size-' + currentDevice)
				var gutter_diff = (1 - s / colCount) * config[currentDevice].colGutter

				var width = 'calc( 100% / ' + colCount + ' * ' + s + ' - ' + gutter_diff + colGutterMu + ')'

				jQuery(this).css({
					width: width,
					'margin-bottom': config[currentDevice].rowGutter + rowGutterMu,
				})
			})
			$el.find('.lay-elementgrid-gutter-sizer').css('width', colGutter + colGutterMu)
			$el.find('.lay-elementgrid-col-sizer').css('width', width)
			// need to re-init masonry, because gutter could have switched from % to px or vice versa
			initLayoutType($el, config)
			// Update image sizes after layout is reinitialized
			// Use setTimeout to ensure masonry layout has been applied
			setTimeout(function () {
				utility_controller.setImageSizesAttribute($el)
			}, 0)
			break
		case 'same-height':
			$el.find('.element-wrap')
				.css({
					'margin-bottom': config[currentDevice].rowGutter + rowGutterMu,
				})
				.find('.img img, .html5video video, .thumb img, .thumb video')
				.each(function () {
					var $el = jQuery(this)
					var w = $el.attr('data-w')
					var h = $el.attr('data-h')
					if (w != undefined && h != undefined) {
						var newH = elementHeight
						var newW = (w / h) * newH
						// setting width instead of height. otherwise safari has issues with the image being blurry sometimes
						$el.css({
							width: newW,
						})
					} else {
						// fallback if no data-w and data-h attribute is set. might lead to a blurry image in safari
						$el.css({
							height: elementHeight,
							width: 'auto',
						})
					}
				})
			$el.find('.element-wrap').css('margin-right', colGutter + colGutterMu)

			// Update image sizes after layout is reinitialized (unwrapping can change image dimensions)
			setTimeout(function () {
				utility_controller.setImageSizesAttribute($el)
			}, 0)

			// youtube vimeo
			$el.find('.element-wrap .video iframe').each(function () {
				var $el = jQuery(this)
				var w = $el.attr('width')
				var h = $el.attr('height')
				if (w != undefined && h != undefined) {
					var newH = elementHeight
					var newW = (w / h) * newH
					$el.css({
						width: newW,
						height: newH,
					})
				} else {
					// fallback if no width and height attribute is set. might lead to a blurry image in safari
					$el.css({
						height: elementHeight,
						width: 'auto',
					})
				}
			})

			var carouselSized = false

			// carousels
			$el.find('.element-wrap .lay-carousel').each(function () {
				var $carousel = jQuery(this)
				var $firstSlide = jQuery(this).find('.lay-carousel-slide:first-child')
				if ($firstSlide.find('img').length > 0) {
					var $img = $firstSlide.find('img')
					var w = $img.attr('data-w')
					var h = $img.attr('data-h')
					if (w != undefined && h != undefined) {
						var newH = elementHeight
						var newW = (w / h) * newH
						$carousel.css({
							width: newW,
							height: newH,
						})
						$carousel.find('.swiper-container, .lay-carousel-slide').css({
							width: newW,
							height: newH,
						})
						carouselSized = true
					}
				} else if ($firstSlide.find('video').length > 0) {
					var $video = $firstSlide.find('video')
					var w = $video.attr('data-w')
					var h = $video.attr('data-h')
					if (w != undefined && h != undefined) {
						var newH = elementHeight
						var newW = (w / h) * newH
						$carousel.css({
							width: newW,
							height: newH,
						})
						$carousel.find('.swiper-container, .lay-carousel-slide').css({
							width: newW,
							height: newH,
						})
						carouselSized = true
					}
				} else {
					// maybe its a text or sth in the first slide.
					// just use a standard width
					$carousel.css({
						height: 'auto',
						width: '200px',
					})
					$carousel.find('.swiper-container, .lay-carousel-slide').css({
						width: '200px',
						height: 'auto',
					})
					carouselSized = true
				}
			})
			// if we sized the carousel, probably it was width 0 before, so now we need to load the first lazy image:
			if (carouselSized) {
				// seems like we need to wait a bit for the carousel to be visible, then this will take effect:
				setTimeout(function () {
					if (typeof window.layCarouselFadeCarousel != 'undefined' && typeof window.layCarouselFadeCarousel.loadFirstLazyImage != 'undefined') {
						window.layCarouselFadeCarousel.loadFirstLazyImage($el)
					}
					if (typeof window.layCarouselScrollCarousel != 'undefined' && typeof window.layCarouselScrollCarousel.loadFirstLazyImage != 'undefined') {
						window.layCarouselScrollCarousel.loadFirstLazyImage($el)
					}
					if (typeof window.layCarouselSwiper != 'undefined' && typeof window.layCarouselSwiper.loadFirstLazyImage != 'undefined') {
						window.layCarouselSwiper.loadFirstLazyImage($el)
					}
				}, 100)
			}
			break
		default:
			// we need to re-init the layout there, because we need to unwrap and wrap the elements, cause we use a wrapping row div
			initLayoutType($el, config)
			$el.find('.element-wrap').css({
				width: width,
				'margin-bottom': config[currentDevice].rowGutter + rowGutterMu,
			})
			// Update image sizes after layout is reinitialized (wrapping/unwrapping can change image dimensions)
			setTimeout(function () {
				utility_controller.setImageSizesAttribute($el)
			}, 0)
			$el.find('.element-wrap').css('margin-right', colGutter + colGutterMu)
			$el.find('.element-wrap:nth-child(' + colCount + 'n)').css('margin-right', 0)
			break
	}

	// safari has issues displaying the correct image resolution here sometimes, so i do this:
	// if (layoutType == 'same-height') {
	// 	setTimeout(function () {
	// 		window.layUpdateImageSizes()
	// 	}, 0)
	// }

	applyRowLimit($el, config)
}

var initLayoutType = function ($el, config) {
	var currentDevice = Utility.screenSize

	switch (config.layoutType) {
		case 'masonry':
			if ($el.find('.lay-elementgrid-gutter-sizer').length == 0) {
				$el.find('.element-collection').append('<div class="lay-elementgrid-gutter-sizer"></div><div class="lay-elementgrid-col-sizer"></div>')
			}

			var elem = $el.find('.element-collection')[0]

			var gutter = '.lay-elementgrid-gutter-sizer'
			var colGutterMu = typeof config[currentDevice].colGutterMu === 'undefined' ? '%' : config[currentDevice].colGutterMu
			if (colGutterMu === 'px') {
				gutter = config[currentDevice].colGutter
			}

			var masonry = new Masonry(elem, {
				// options
				itemSelector: '.element-wrap',
				columnWidth: '.lay-elementgrid-col-sizer',
				gutter: gutter,
				percentPosition: true,

				transitionDuration: 0,
			})
			// somehow this only works on reload: :/, for thumbnailgrid_controller.js it works
			// not sure why!
			// fixing this by adding 'masonry-initialized' at end of this javascript file
			masonry.once('layoutComplete', function () {
				$el.closest('.col').addClass('masonry-initialized')
			})
			$el.data('masonry', masonry)
			break
		case 'same-height':
			var $thumbnails = $el.find('.element-wrap')

			// need to unwrap first?
			var $thumbs = $el.find('.elementgrid-row .element-wrap')
			// need to unwrap?
			if ($thumbs.length > 0) {
				$thumbs.unwrap()
			}
			break
		default:
			var $thumbnails = $el.find('.element-wrap')

			// need to unwrap first?
			var $thumbs = $el.find('.elementgrid-row .element-wrap')
			// need to unwrap?
			if ($thumbs.length > 0) {
				$thumbs.unwrap()
			}

			// http://stackoverflow.com/questions/3366529/wrap-every-3-divs-in-a-div
			var colCount = config[currentDevice].colCount
			for (var i = 0; i < $thumbnails.length; i += colCount) {
				$thumbnails.slice(i, i + colCount).wrapAll('<div class="elementgrid-row ' + config.layoutType + '"></div>')
			}
			break
	}
}

var layoutMasonryOnResize = function () {
	// size masonry so it doesnt relayout on resize end but continuously
	if (typeof $grids != 'undefined') {
		$grids.each(function () {
			var $el = jQuery(this)
			var config = $el.data('config')
			var layoutType = config.layoutType
			if (layoutType === 'masonry') {
				var masonry = $el.data('masonry')
				if (typeof masonry != 'undefined') {
					masonry.layout()
				}
			}
		})
	}
}

var i = function () {
	jQuery(window).on('window_width_changed', layoutMasonryOnResize)
	// otherwise, masonry doesnt position elements correctly for scrollslider:
	window.laytheme.on('scrollslider-initialized', layoutMasonryOnResize)
	// size changed between phone, tablet, desktop, re-init layouts
	window.laytheme.on('sizechanged', onResize)
	bindOnContentReady()

	// re-layout after a second, cause fonts might have loaded now
	setTimeout(function () {
		layoutMasonryOnResize()
	}, 1000)
}

var bindOnContentReady = function () {
	window.laytheme.on('content_ready', function (typeOfContentThatIsReady) {
		$grids = undefined
		var $target
		$target = getTargetContainersExceptPageOverlay(typeOfContentThatIsReady)
		initGrids($target)
	})

	window.laytheme.on('overlayshown', function ($target) {
		// only do all this once per page overlay:
		if ($target.hasClass('lay-overlay-was-opened-at-least-once')) {
			return
		}
		initGrids($target)
	})
}

var initGrids = function ($target) {
	if ($grids == undefined) {
		$grids = $target.find('.elements-collection-region')
	} else {
		var $newGrids = $target.find('.elements-collection-region')
		$grids = $grids.add($newGrids)
	}

	$grids.each(function () {
		if (!jQuery(this).hasClass('initialized')) {
			var $el = jQuery(this)
			var config = $el.data('config')

			// Restore load more state from sessionStorage
			var elementType = restoreLoadMore.getElementType($el)
			var elementId = restoreLoadMore.getElementId($el)
			if (elementType && elementId) {
				if (!restoreLoadMore.isRememberEnabled()) {
					restoreLoadMore.clearLoadMoreState(elementType, elementId)
				} else {
					var savedState = restoreLoadMore.getLoadMoreState(elementType, elementId)
					if (savedState) {
						if (savedState.isRowLayout && savedState.multiplier && savedState.multiplier > 1) {
							$el.attr('data-rows-shown', savedState.multiplier)
						} else if (!savedState.isRowLayout && savedState.itemsShown && savedState.itemsShown > 0) {
							// Restore items shown for non-row layouts
							var $items = $el.find('.element-wrap.hide-elementgrid')
							var itemsToShow = Math.min(savedState.itemsShown, $items.length)
							$items.slice(0, itemsToShow).removeClass('hide-elementgrid').addClass('show-elementgrid loadmore-shown')
						}
					}
				}
			}

			initLayoutType($el, config)
			// Apply row limit after restoring state
			applyRowLimit($el, config)
			sizeLayout($el, config)

			// sometimes on an iphone, this class doesnt get added, and i have no idea why
			this.classList.add('initialized')
			// just as a safety measure, because sometimes layoutComplete doesnt trigger
			if (config.layoutType == 'masonry') {
				$el.closest('.col').addClass('masonry-initialized')
			}
		} else {
			// when switching from cpl to normal layout, the layout was initialized already, but it does nee to be sized again:
			var $el = jQuery(this)
			var config = $el.data('config')
			sizeLayout($el, config)
		}
	})

	// lazySizes.autoSizer.checkElems();
	utility_controller.setImageSizesAttribute($grids)
}

var getRowsToShow = function (config, device) {
	if (!config || !config[device]) {
		return 0
	}
	var rows = typeof config[device].rowsToShow === 'undefined' ? rowsToShowDefaults[device] : Number(config[device].rowsToShow)
	if (isNaN(rows) || rows < 0) {
		rows = 0
	}
	return rows
}

var getLimitForDevice = function (config, device) {
	var rows = getRowsToShow(config, device)
	if (rows <= 0) {
		return -1
	}
	var colCount = config[device] && typeof config[device].colCount !== 'undefined' ? Number(config[device].colCount) : 1
	if (isNaN(colCount) || colCount < 1) {
		colCount = 1
	}
	return rows * colCount
}

var applyRowLimit = function ($el, config) {
	var showMoreEnabled = config.showMoreButton === true || config.showMoreButton === 'true'
	var limit = getLimitForDevice(config, Utility.screenSize)
	var $buttonWrap = $el.nextAll('.lay-elementgrid-load-more-wrap').first()
	var $button = $buttonWrap.length > 0 ? $buttonWrap.find('.lay-elementgrid-load-more').first() : jQuery()
	var $items = $el.find('.element-wrap')
	var layoutType = config.layoutType
	var isRowLayout = layoutType !== 'masonry' && layoutType !== 'same-height'

	$items.removeClass('hide-elementgrid').addClass('show-elementgrid')
	if (isRowLayout) {
		$el.find('.elementgrid-row').removeClass('hide-elementgrid-row show-elementgrid-row')
	}

	if (!showMoreEnabled || limit === -1) {
		if ($button.length) {
			$button.hide()
		}
		return
	}

	if (isRowLayout) {
		var rowsToShow = getRowsToShow(config, Utility.screenSize)
		if (rowsToShow <= 0) {
			if ($button.length) {
				$button.hide()
			}
			return
		}
		// Get multiplier from data attribute (defaults to 1 for initial load)
		var multiplier = Number($el.attr('data-rows-shown') || 1)
		if (!$el.attr('data-rows-shown')) {
			$el.attr('data-rows-shown', 1)
		}
		var totalRowsToShow = rowsToShow * multiplier
		var $rows = $el.find('.elementgrid-row')
		var visibleRows = 0
		$rows.each(function () {
			var $row = jQuery(this)
			if (visibleRows < totalRowsToShow) {
				visibleRows++
				$row.removeClass('hide-elementgrid-row').addClass('show-elementgrid-row')
				$row.find('.element-wrap').removeClass('hide-elementgrid').addClass('show-elementgrid')
			} else {
				$row.removeClass('show-elementgrid-row').addClass('hide-elementgrid-row')
				$row.find('.element-wrap').removeClass('show-elementgrid').addClass('hide-elementgrid')
			}
		})
		var hiddenRows = $rows.filter('.hide-elementgrid-row').length
		if ($button.length) {
			if (hiddenRows === 0) {
				$button.hide()
			} else {
				$button.show()
			}
		}
		return
	}

	var visibleCount = 0
	$items.each(function () {
		var $item = jQuery(this)
		if ($item.hasClass('loadmore-shown')) {
			return
		}
		if (visibleCount < limit) {
			visibleCount++
		} else {
			$item.removeClass('show-elementgrid').addClass('hide-elementgrid')
		}
	})

	if ($el.find('.element-wrap.hide-elementgrid').length === 0) {
		if ($button.length) {
			$button.hide()
		}
	} else {
		if ($button.length) {
			$button.show()
		}
	}
}

jQuery(document).on('click', '.lay-elementgrid-load-more', function (event) {
	event.preventDefault()
	var $button = jQuery(this)
	var $wrap = $button.closest('.lay-elementgrid-load-more-wrap').prevAll('.elements-collection-region').first()
	if ($wrap.length === 0) {
		$wrap = $button.closest('.lay-elementgrid-wrap').find('.elements-collection-region').first()
	}
	if ($wrap.length === 0) {
		return
	}
	var config = $wrap.data('config')
	if (!config) {
		$button.hide()
		return
	}
	var layoutType = config.layoutType
	var isRowLayout = layoutType !== 'masonry' && layoutType !== 'same-height'
	if (isRowLayout) {
		var rowsToShow = getRowsToShow(config, Utility.screenSize)
		if (rowsToShow <= 0) {
			$button.hide()
			return
		}
		// Increment multiplier and store it
		var multiplier = Number($wrap.attr('data-rows-shown') || 1)
		multiplier++
		$wrap.attr('data-rows-shown', multiplier)

		// Save load more state to sessionStorage
		var elementType = restoreLoadMore.getElementType($wrap)
		var elementId = restoreLoadMore.getElementId($wrap)
		if (elementType && elementId) {
			if (restoreLoadMore.isRememberEnabled()) {
				restoreLoadMore.saveLoadMoreState(elementType, elementId, { multiplier: multiplier, isRowLayout: true })
			} else {
				restoreLoadMore.clearLoadMoreState(elementType, elementId)
			}
		}

		// applyRowLimit will use the new multiplier to show more rows
		applyRowLimit($wrap, config)
		sizeLayout($wrap, config)
		utility_controller.setImageSizesAttribute($wrap)
		layoutMasonryOnResize()

		// Scroll animations are handled automatically by the IntersectionObserver:
		// Hidden elements already have the 'below' class from initial setup,
		// so when they become visible, the observer will automatically trigger the animation

		if (typeof window.laytheme != 'undefined' && typeof window.laytheme.emit === 'function') {
			window.laytheme.emit('elementGridLoadMore', $wrap)
		}
		return
	}
	var limit = getLimitForDevice(config, Utility.screenSize)
	var $hidden = $wrap.find('.element-wrap.hide-elementgrid')
	var itemsShown = 0
	if (limit === -1) {
		itemsShown = $hidden.length
		$hidden.removeClass('hide-elementgrid').addClass('show-elementgrid loadmore-shown')
	} else {
		$hidden.each(function (index) {
			if (index < limit) {
				itemsShown++
				jQuery(this).removeClass('hide-elementgrid').addClass('show-elementgrid loadmore-shown')
			}
		})
	}

	// Save load more state to sessionStorage (for non-row layout)
	var elementType = restoreLoadMore.getElementType($wrap)
	var elementId = restoreLoadMore.getElementId($wrap)
	if (elementType && elementId) {
		var currentShown = $wrap.find('.element-wrap.loadmore-shown').length
		if (restoreLoadMore.isRememberEnabled()) {
			restoreLoadMore.saveLoadMoreState(elementType, elementId, { itemsShown: currentShown, isRowLayout: false })
		} else {
			restoreLoadMore.clearLoadMoreState(elementType, elementId)
		}
	}

	if ($wrap.find('.element-wrap.hide-elementgrid').length === 0) {
		$button.hide()
	}

	// Scroll animations are handled automatically by the IntersectionObserver:
	// Hidden elements already have the 'below' class from initial setup,
	// so when they become visible, the observer will automatically trigger the animation

	if (config.layoutType === 'masonry') {
		var masonry = $wrap.data('masonry')
		if (typeof masonry != 'undefined' && masonry !== null) {
			masonry.reloadItems()
			masonry.layout()
		} else {
			initLayoutType($wrap, config)
		}
	}
	sizeLayout($wrap, config)
	utility_controller.setImageSizesAttribute($wrap)
	layoutMasonryOnResize()
	if (typeof window.laytheme != 'undefined' && typeof window.laytheme.emit === 'function') {
		window.laytheme.emit('elementGridLoadMore', $wrap)
	}
})

var elementgrid_controller = {
	i: i,
}

export default elementgrid_controller
